import React, { useEffect } from 'react';
import cls from '@utils/css-select'
import PageContainer from 'containers/ac-containers/page-container';
import ProfileInfo from './components/profile-info/main';
import TransactionRecord from './components/transaction-record/main';
import AcBtn from 'ac-components/ac-btn';
import styles from './styles.scss';
import logOut from 'containers/ac-containers/logout'
import { sendEvent } from '@core/track';
import { useTranslation } from 'hooks/use-translation';

const cx = cls(styles)

function Personal() {
	const { transData } = useTranslation('profile')
	useEffect(() => {
		sendEvent({
			eventId: 'EAF_501fd6b108a68f57'
		})
	}, [])

	return (
		<PageContainer style={{ 'background': '#F4F9FE' }}>
			<div id='personal-alert-wrap'></div>
			<ProfileInfo />
			<TransactionRecord />
			<div className={cx('log-out_wrap')}>
				<AcBtn
					type='minor'
					className={cx('log-out_btn')}
					onClick={() => logOut(transData)}>
					{transData.logout}
				</AcBtn>
			</div>
		</PageContainer>
	)
}

export default Personal
